export interface MenuCategory {
  id:    string;
  title: string;
  type: 'Gráficas' | 'Reportes' | 'Módulo' | 'Sección';
  items: MenuItem[];
}
export interface MenuItem {
  id:    string;
  item: string;
  route: string;
}

export interface MenuSection {
  id:string;
  title: string;
  icon: string;
  route?:string;
  categories?: MenuCategory[];
}
